/*
 * Make sure nothing in this directory references node-specific APIs
 * at least `components` will be accessed in the browser for proptype validation
 */
module.exports = {
  components: require('./components'),
  appearances: require('./appearances'),
  tokens: require('./tokens')
}
